import React from 'react';

const TimesheetCalendarSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Calendar Header */}
      <div className="mb-4 text-center">
        <div className="h-6 w-48 bg-gradient-to-r from-gray-200 to-gray-300 rounded mx-auto"></div>
      </div>

      {/* Day Headers */}
      <div className="grid grid-cols-7 gap-2 mb-2">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
          <div key={day} className="h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div className="space-y-2">
        {[...Array(5)].map((_, weekIndex) => (
          <div key={weekIndex} className="grid grid-cols-7 gap-2">
            {[...Array(7)].map((_, dayIndex) => (
              <div
                key={dayIndex}
                className="min-h-[120px] border border-border rounded-lg p-2 bg-white animate-pulse"
              >
                {/* Date Number */}
                <div className="h-4 w-6 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2"></div>

                {/* Entry Skeletons */}
                <div className="space-y-1">
                  {/* Summary badge */}
                  <div className="h-3 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>

                  {/* Entry indicators */}
                  <div className="space-y-1">
                    {[...Array(2)].map((_, i) => (
                      <div
                        key={i}
                        className="h-8 w-full bg-gradient-to-r from-gray-200 to-gray-300 rounded"
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="mt-6 flex flex-wrap gap-4 justify-center">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gradient-to-r from-gray-200 to-gray-300"></div>
            <div className="h-4 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimesheetCalendarSkeleton;
